import {Checkbox, Form, FormProps, Input, Select,} from "antd";
import {useContext, useEffect, useRef} from "react";
import BMReadOnly from "../BMReadOnly";
import {AssemblyInfo, AXIOS_CANCEL_MSG, Page} from "../../api/models";
import axios, {CancelTokenSource} from "axios";
import {ConfiguratorContext} from "../../context";
import {FilteredAssembliesRequest} from "../../api";
import useSWR from "swr";

export interface NotificationEventFormValues  {
  id: string;
  name?: string;
  templateId: string;
  disabled?: boolean;
  recipients: string[]
}

export const NotificationEventForm = (props:FormProps & {
}) =>  {

  const {...formProps} = props;

  const notificationIdLst = useNotificationIdList();

  useEffect(() => {
    props.form?.resetFields();
  }, [props.initialValues] );

  return <Form 
    {...formProps}
    layout="vertical"
  >
    <Form.Item name="id" 
      label="Id"

    >
        <Select
            showSearch
            allowClear
            loading={notificationIdLst.isLoading}
            options={notificationIdLst.data?.map(id => ({ label: id, value: id }))}
        />
    </Form.Item>

    <Form.Item name="name"
               label="Name"
    >
      <Input />
    </Form.Item>

    <Form.Item name="templateId"
               label="Template Id"
               rules={[{
                 required: true,
                 message: `This is the sendgrid template id.`,
               }]}
    >
      <Input />
    </Form.Item>

    <Form.Item name="recipients"
               label="Recipients"
               rules={[{
                   required: true,
                   message: `At least one recipient must be specified`,
               }]}
    >
      <Select
          mode="tags"
          allowClear
          options={[
              { value: 'SalesDeskEmail'},
              { value: 'SalesManagerEmail'},
              { value: 'SalesDirectorEmail'},
              { value: 'SalesEmail'},
              { value: 'EngineeringEmail'},
              { value: 'ReleaseEngineeringEmail'},
              { value: 'OrderSubmittedEmail'},
              { value: 'ExcoEmail'},
              { value: 'ProcurementEmail'},
              { value: 'SalesConcessionNotificationEmail'},
              { value: 'FinanceEmail'},
              { value: 'ProductionLeadEmail'},
              { value: 'SalesSupportEmail'},
              { value: 'OrderSupportEmail'},
              { value: 'ShipmentStatusUpdateEmail'},
              { value: 'SalesTeam'},
              { value: 'SalesTeamSupport'},
              { value: 'SalesTeamEngineers'},
              { value: 'SalesTeamViewers'},
              { value: 'QuoteOwner'},
              { value: 'Approvers'}
          ]}
      />
    </Form.Item>

    <Form.Item
        valuePropName="checked"
        label="Disabled"
        name="disabled"
    >
      <Checkbox />
    </Form.Item>



  </Form>


}

export const useNotificationIdList = () => {

    const cancelTokenSourceRef = useRef<CancelTokenSource>();
    const configurator = useContext(ConfiguratorContext);

    const fetcher = async () : Promise<string[] | undefined> => {

        if ( cancelTokenSourceRef.current ) {
            cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
        }
        const cancelSource = axios.CancelToken.source();
        cancelTokenSourceRef.current = cancelSource;


        try {
            const resp = await configurator.api.fetchNotificationIdList(cancelSource.token )
            cancelTokenSourceRef.current = undefined;

            return resp.data;
        }
        catch(e: any) {
            const id = e.response?.data?.message || e.message ;
            if ( id === AXIOS_CANCEL_MSG ) return;
            throw e;
        }
    }

    // Use SWR for data fetching
    return useSWR([
            'fetchNotificationIdInfoList',
        ],
        ([_k]) => fetcher(),
        {
            //maybe unnecessary
            revalidateOnFocus: false,
            //maybe unnecessary
            dedupingInterval:1
        }
    );
};

export default NotificationEventForm;
